import { ShowEmoticonEvent } from '@common/events';

import { ClientEventSystem } from './ClientBase';

/**
 * System that renders transient emoticons (emojis) above entities.
 * Listens for ShowEmoticonEvent and delegates rendering to EmoticonService.
 */
export class EmoticonSystem extends ClientEventSystem<'ShowEmoticon'> {
  public eventTypes: 'ShowEmoticon'[] = ['ShowEmoticon'];

  handleEvent(event: ShowEmoticonEvent): void {
    const { entityId, emoticonId } = event.payload;
    this.clientServices.emoticon.showEmoticon(entityId, emoticonId);
  }

  override run(deltaTime: number): void {
    // 1. Process new events via handleEvent (called by super.run)
    super.run(deltaTime);

    // 2. Update service (handles animation and cleanup)
    this.clientServices.emoticon.update(deltaTime);
  }
}
